import React, { useEffect } from 'react';
import './index.less';

const WithAudio = ({ size }: { size?: number }) => {
  return (
    <div
      style={{ width: size, height: size }}
      className={'grocery-with-audio-icon'}
    />
  );
};

const WithVideo = ({ size }: { size?: number }) => {
  return (
    <div
      style={{ width: size, height: size }}
      className={'grocery-with-video-icon'}
    />
  );
};

const Iframe = ({ node, next }) => {
  useEffect(() => {
    const fit = () => {
      const detailElement = document.getElementById('post-detail-content');
      const iframe = document.getElementById(node.uid);
      if (iframe) {
        iframe.style.height = (detailElement?.scrollWidth / 16) * 9 + 'px';
      }
    };
    window.onresize = fit;
    fit();
  }, [node.uid]);
  return (
    <iframe id={node.uid} src={node.attrs?.src} width="100%" height="300px">
      {next(node.children)}
    </iframe>
  );
};

export { WithAudio, WithVideo, Iframe };
